import React, {useEffect, useState} from 'react';
import NavBar from "./components/NavBar";
import Header from "./components/Header";
import axios from "axios";
import SuccessPopUp from "./helpers/SuccessPopUp";
import FailPopUp from "./helpers/FailPopUp";
import {Link, useLocation} from "react-router-dom";

interface Product {
    id: number;
    product_title_lv: string;
    product_title_eng: string;
    product_title_ru: string;
    product_desc_lv: string;
    product_desc_eng: string;
    product_desc_ru: string;
    size: string;
    price: string;
    main_image: string | null;
    created_at: string;
}

interface ProductList {
    products: Product[];
}


const Products: React.FC = () => {
    const [loader, setLoader] = useState(true)

    const [successPopUp, setSuccessPopUp] = useState(false)
    const [failPopUp, setFailPopUp] = useState(false)
    const [message, setMessage] = useState('')

    const [deleteConfirmModal, setDeleteConfirmModal] = useState<Boolean>(false)

    const [deleteId, setDeleteId] = useState(null)

    const [data, setData] = useState<ProductList>()

    const [isNavBarMinimized, setIsNavBarMinimized] = useState(false);

    const API_URL = `${process.env.REACT_APP_API_URL}`

    const location = useLocation();
    const { editMessage, editSuccessPopUp } = location.state || {};

    const { addMessage, addSuccessPopUp } = location.state || {}

    const [showSuccessPopUp, setShowSuccessPopUp] = useState(successPopUp || false);
    const [popupMessage, setPopupMessage] = useState(message || "");

    useEffect(() => {
        if (editSuccessPopUp) {
            setShowSuccessPopUp(true);
            setPopupMessage(editMessage);
        }
    }, [editSuccessPopUp, editMessage]);

    useEffect(() => {
        if (addSuccessPopUp) {
            setShowSuccessPopUp(true);
            setPopupMessage(addMessage);
        }
    }, [addSuccessPopUp, addMessage]);


    const toggleSidebar = () => {
        setIsNavBarMinimized(!isNavBarMinimized);
    };

    const openDeleteModal = (id: number) => {
        setDeleteConfirmModal(true)
        // @ts-ignore
        setDeleteId(id)
    }

    const closeDeleteModal = () => {
        setDeleteConfirmModal(false)
        setDeleteId(null)
    }


    const fetchData = () => {
        axios.get(`${API_URL}/products`, {withCredentials: true})
            .then(response => {
                setData(response.data)
                setLoader(false)
            })
            .catch(errors => {
                setLoader(false)
            })
    }

    useEffect(()=>{
       fetchData()
    }, [])

    const handleDelete = async (id: number|null) => {
        await axios.delete(`${API_URL}/delete-product/${id}`, {withCredentials: true})
            .then(response => {
                if(response.status === 200)
                {
                    setDeleteConfirmModal(false)
                    setMessage(response.data.message)
                    setSuccessPopUp(true)
                    fetchData()
                }
            })
            .catch(error => {
                if(error.status === 500 || error.status === 404)
                {
                    setDeleteConfirmModal(false)
                    setMessage(error.message)
                    setFailPopUp(true)
                }
            })
    }

    return (
        <>
        {showSuccessPopUp && <SuccessPopUp message={popupMessage} setSuccessPopUp={setShowSuccessPopUp}/>}
        {successPopUp && <SuccessPopUp message={message} setSuccessPopUp={setSuccessPopUp}/>}

        {failPopUp && <FailPopUp message={message} setFailPopUp={setFailPopUp}/>}
        <div className="h-screen">
            <NavBar isNavbarMinimized={isNavBarMinimized}/>
            <div className={`flex flex-col  md:ml-[290px] h-screen overflow-y-scroll ml-0 transition-all duration-300 ease-in-out`}>
                <Header toggleSidebar={toggleSidebar} isNavBarMinimized={isNavBarMinimized}/>
                <div className="bg-neutral-100 flex flex-col flex-grow p-6">
                    <h1 className="pb-4 text-xl font-medium text-gray-800">Product Table</h1>
                   <div className="bg-white border border-gray-200 flex flex-col flex-grow rounded-2xl">
                       <h2 className="p-6 border-b border-gray-200 text-gray-700 font-medium">Products</h2>
                       <div className="p-6 relative">
                           {loader && (
                               <div className="absolute position-center flex flex-col space-x-3 items-center justify-center">
                                   <div className="w-6 h-6 border-4 border-t-blue-500 border-gray-200 rounded-full animate-spin"></div>
                               </div>
                           )}
                           <div className="max-w-full overflow-hidden">
                               <div className="border border-gray-200 rounded-2xl overflow-x-auto overflow-y-auto">
                                   <div className="min-w-[1024px] h-[500px]">

                                       <table className="w-full overflow-x-auto">
                                            <thead className="bg-gray-50 sticky top-0 w-full">
                                                <tr>
                                                    <th className="font-medium text-xs p-4 text-gray-500 rounded-tl-2xl">Nr</th>
                                                    <th className="font-medium text-xs py-4 text-gray-500 text-left">Product</th>
                                                    <th className="font-medium text-xs py-4 text-gray-500 text-left">Image</th>
                                                    <th className="font-medium text-xs py-4 text-gray-500 text-left">Price</th>
                                                    <th className="font-medium text-xs py-4 text-gray-500 text-left">Date Created</th>
                                                    <th className="font-medium text-xs py-4 text-gray-500 text-left rounded-tr-2xl">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody >
                                            {loader ? (''):(
                                                data && Array.isArray(data) && data.map((item: Product, index: number) => (
                                                    <tr key={item.id} className="whitespace-nowrap">
                                                        <td className="text-center text-gray-700 py-3 h-12">{index+1}</td>
                                                        <td className="text-gray-700 py-3 h-12">{item.product_title_lv}</td>
                                                        <td className="text-gray-700 py-3 h-12">
                                                            {item.main_image && (
                                                                <img
                                                                    className="h-12 w-12 rounded-full"
                                                                    src={item.main_image}
                                                                    alt={item.product_title_lv}
                                                                />
                                                            )}
                                                        </td>
                                                        <td className="text-gray-700 py-3 h-12">{item.price === 'Sold' ? item.price : item.price+" €"} </td>
                                                        <td className="text-gray-700 py-3 h-12">{item.created_at}</td>
                                                        <td className="py-3">
                                                            <div className="flex space-x-3">
                                                                <svg onClick={() => openDeleteModal(item.id)} className="stroke-gray-700 hover:stroke-red-500 cursor-pointer h-5 aspect-square" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                                                                    <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                                                                    <g id="SVGRepo_iconCarrier">
                                                                        <path d="M20.5001 6H3.5" strokeWidth="1.5" strokeLinecap="round"></path>
                                                                        <path d="M9.5 11L10 16" strokeWidth="1.5" strokeLinecap="round"></path>
                                                                        <path d="M14.5 11L14 16" strokeWidth="1.5" strokeLinecap="round"></path>
                                                                        <path d="M6.5 6C6.55588 6 6.58382 6 6.60915 5.99936C7.43259 5.97849 8.15902 5.45491 8.43922 4.68032C8.44784 4.65649 8.45667 4.62999 8.47434 4.57697L8.57143 4.28571C8.65431 4.03708 8.69575 3.91276 8.75071 3.8072C8.97001 3.38607 9.37574 3.09364 9.84461 3.01877C9.96213 3 10.0932 3 10.3553 3H13.6447C13.9068 3 14.0379 3 14.1554 3.01877C14.6243 3.09364 15.03 3.38607 15.2493 3.8072C15.3043 3.91276 15.3457 4.03708 15.4286 4.28571L15.5257 4.57697C15.5433 4.62992 15.5522 4.65651 15.5608 4.68032C15.841 5.45491 16.5674 5.97849 17.3909 5.99936C17.4162 6 17.4441 6 17.5 6" strokeWidth="1.5"></path>
                                                                        <path d="M18.3735 15.3991C18.1965 18.054 18.108 19.3815 17.243 20.1907C16.378 21 15.0476 21 12.3868 21H11.6134C8.9526 21 7.6222 21 6.75719 20.1907C5.89218 19.3815 5.80368 18.054 5.62669 15.3991L5.16675 8.5M18.8334 8.5L18.6334 11.5" strokeWidth="1.5" strokeLinecap="round"></path>
                                                                    </g>
                                                                </svg>
                                                                <Link to={`/edit-product/${item.product_title_eng}`}>
                                                                    <svg className="stroke-gray-700 hover:stroke-blue-500 cursor-pointer h-5 aspect-square" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                                                                        <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                                                                        <g id="SVGRepo_iconCarrier">
                                                                            <path d="M14.3601 4.07866L15.2869 3.15178C16.8226 1.61607 19.3125 1.61607 20.8482 3.15178C22.3839 4.68748 22.3839 7.17735 20.8482 8.71306L19.9213 9.63993M14.3601 4.07866C14.3601 4.07866 14.4759 6.04828 16.2138 7.78618C17.9517 9.52407 19.9213 9.63993 19.9213 9.63993M14.3601 4.07866L12 6.43872M19.9213 9.63993L14.6607 14.9006L11.5613 18L11.4001 18.1612C10.8229 18.7383 10.5344 19.0269 10.2162 19.2751C9.84082 19.5679 9.43469 19.8189 9.00498 20.0237C8.6407 20.1973 8.25352 20.3263 7.47918 20.5844L4.19792 21.6782M4.19792 21.6782L3.39584 21.9456C3.01478 22.0726 2.59466 21.9734 2.31063 21.6894C2.0266 21.4053 1.92743 20.9852 2.05445 20.6042L2.32181 19.8021M4.19792 21.6782L2.32181 19.8021M2.32181 19.8021L3.41556 16.5208C3.67368 15.7465 3.80273 15.3593 3.97634 14.995C4.18114 14.5653 4.43213 14.1592 4.7249 13.7838C4.97308 13.4656 5.26166 13.1771 5.83882 12.5999L8.5 9.93872" strokeWidth="1.5" strokeLinecap="round"></path>
                                                                        </g>
                                                                    </svg>
                                                                </Link>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))
                                            )}
                                            </tbody>
                                        </table>
                                       {deleteConfirmModal && (
                                           <div className="fixed flex top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 items-center justify-center z-50 h-screen w-full bg-opacity-50 bg-black ">
                                               <div className="flex flex-col items-center text-center mx-2 w-[25rem] space-y-5 bg-white p-4 py-4 rounded-xl border border-gray-200">
                                                    <div className="bg-red-100 rounded-full p-4">
                                                        <svg className="stroke-red-500 h-20 aspect-square" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                                                            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                                                            <g id="SVGRepo_iconCarrier">
                                                                <path d="M20.5001 6H3.5" strokeWidth="1.5" strokeLinecap="round"></path>
                                                                <path d="M9.5 11L10 16" strokeWidth="1.5" strokeLinecap="round"></path>
                                                                <path d="M14.5 11L14 16" strokeWidth="1.5" strokeLinecap="round"></path>
                                                                <path d="M6.5 6C6.55588 6 6.58382 6 6.60915 5.99936C7.43259 5.97849 8.15902 5.45491 8.43922 4.68032C8.44784 4.65649 8.45667 4.62999 8.47434 4.57697L8.57143 4.28571C8.65431 4.03708 8.69575 3.91276 8.75071 3.8072C8.97001 3.38607 9.37574 3.09364 9.84461 3.01877C9.96213 3 10.0932 3 10.3553 3H13.6447C13.9068 3 14.0379 3 14.1554 3.01877C14.6243 3.09364 15.03 3.38607 15.2493 3.8072C15.3043 3.91276 15.3457 4.03708 15.4286 4.28571L15.5257 4.57697C15.5433 4.62992 15.5522 4.65651 15.5608 4.68032C15.841 5.45491 16.5674 5.97849 17.3909 5.99936C17.4162 6 17.4441 6 17.5 6" strokeWidth="1.5"></path>
                                                                <path d="M18.3735 15.3991C18.1965 18.054 18.108 19.3815 17.243 20.1907C16.378 21 15.0476 21 12.3868 21H11.6134C8.9526 21 7.6222 21 6.75719 20.1907C5.89218 19.3815 5.80368 18.054 5.62669 15.3991L5.16675 8.5M18.8334 8.5L18.6334 11.5" strokeWidth="1.5" strokeLinecap="round"></path>
                                                            </g>
                                                        </svg>
                                                    </div>
                                                   <div className="flex flex-col items-center space-y-2">
                                                    <h1 className="text-3xl text-gray-800">Are you sure?</h1>
                                                       <div className="text-gray-500">
                                                           <h2>Do you want to delete this product?</h2>
                                                           <h2>This action <strong>cannot</strong> be undone!</h2>
                                                       </div>
                                                       <div className="flex space-x-2">
                                                           <button onClick={() => handleDelete(deleteId)} className="admin-btn bg-red-500 p-3 hover:bg-red-600 mt-4 ml-auto">Delete</button>
                                                           <button onClick={closeDeleteModal} className="admin-btn bg-white text-gray-800 hover:bg-gray-200 border border-gray-200 mt-4 ml-auto">Cancel</button>
                                                       </div>
                                                   </div>
                                               </div>
                                           </div>
                                           )}
                                       </div>
                                    </div>
                               </div>
                           </div>
                       </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Products;